import { withAppCrashIfException } from 'epic';
import {
  loadPreferenceStateEpic,
  persistPreferenceStateEpic,
} from 'epic/blotters/scheduledQuotesBlotter/preferenceState/preferenceStateEpics';
import { combineEpics } from 'redux-observable';

import {
  fetchColumnDefinitionEpic,
  fetchItemsEpic,
  loadFilters,
  persistFilters,
  pollItemsEpic,
} from './scheduledQuotesBlotterEpics';

export const scheduledQuotesBlotterEpics = () =>
  withAppCrashIfException(
    'scheduledQuotesBlotter',
    combineEpics(
      fetchColumnDefinitionEpic(),
      loadFilters(),
      loadPreferenceStateEpic(),
      persistFilters(),
      persistPreferenceStateEpic(),
      pollItemsEpic(),
      fetchItemsEpic(),
    ),
  );
